import type MarkdownIt from 'markdown-it';

import { createLinkify } from './index';

export const createLinkifyPlugin =
	(params: Parameters<typeof createLinkify>[0]) =>
	(md: MarkdownIt): void =>
		md.core.ruler.push('custom-linkify', createLinkify(params));
